import { render, staticRenderFns } from "./PostEditImmoObject4200.vue?vue&type=template&id=25b9f8fb&"
import script from "./PostEditImmoObject4200.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoObject4200.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports